// BERNOA — scripts propios (vanilla, sin dependencias externas)
(function () {
  "use strict";

  function initReveals() {
    var els = document.querySelectorAll(".bn-reveal, .bn-reveal-stagger");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("bn-visible"); });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("bn-visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18, rootMargin: "0px 0px -8% 0px" }
    );
    els.forEach(function (el) { obs.observe(el); });
  }

  function initContadores() {
    var els = document.querySelectorAll("[data-bn-contador]");
    if (!els.length || !("IntersectionObserver" in window)) return;
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          obs.unobserve(el);
          var fin = parseFloat(el.getAttribute("data-bn-contador")) || 0;
          var dec = el.getAttribute("data-bn-decimales") ? parseInt(el.getAttribute("data-bn-decimales"), 10) : 0;
          var dur = 1400;
          var t0 = null;
          function paso(ts) {
            if (!t0) t0 = ts;
            var p = Math.min((ts - t0) / dur, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = (fin * eased).toFixed(dec).replace(".", ",");
            if (p < 1) requestAnimationFrame(paso);
            else el.textContent = fin.toFixed(dec).replace(".", ",");
          }
          requestAnimationFrame(paso);
        });
      },
      { threshold: 0.5 }
    );
    els.forEach(function (el) { obs.observe(el); });
  }

  function initGaleriaProducto(root) {
    var principal = root.querySelector("[data-bn-imagen-principal]");
    var minis = root.querySelectorAll("[data-bn-miniatura]");
    if (!principal || !minis.length) return;

    function mostrar(mini) {
      var src = mini.getAttribute("data-full");
      var alt = mini.getAttribute("data-alt") || "";
      if (!src) return;
      principal.style.opacity = "0";
      window.setTimeout(function () {
        principal.setAttribute("src", src);
        principal.setAttribute("alt", alt);
        principal.style.opacity = "1";
      }, 160);
      minis.forEach(function (m) { m.classList.remove("bn-mini-activa"); });
      mini.classList.add("bn-mini-activa");
    }

    minis.forEach(function (mini) {
      mini.addEventListener("click", function () {
        mostrar(mini);
        var miniColor = mini.getAttribute("data-bn-color") || "all";
        if (miniColor === "all") return;
        var grid = root.closest(".bn-producto-grid");
        var selectColor = grid && grid.querySelector('[data-bn-opcion-nombre="color"]');
        if (!selectColor) return;
        if ((selectColor.value || "").toLowerCase() === miniColor) return;
        var opcion = Array.prototype.find.call(selectColor.options, function (o) {
          return o.value.toLowerCase() === miniColor;
        });
        if (opcion) {
          selectColor.value = opcion.value;
          selectColor.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    });

    // Muestra: todas las fotos del color elegido + una foto "principal" de cada otro color (+ las genéricas "all")
    root.bnFiltrarColor = function (colorSeleccionado) {
      var color = (colorSeleccionado || "").toLowerCase();
      var visibles = [];
      minis.forEach(function (mini) {
        var miniColor = mini.getAttribute("data-bn-color") || "all";
        var tipo = mini.getAttribute("data-bn-tipo") || "principal";
        var coincide = miniColor === "all" || miniColor === color || tipo === "principal";
        mini.style.display = coincide ? "" : "none";
        if (coincide) visibles.push(mini);
      });
      var preferida = visibles.find(function (m) { return (m.getAttribute("data-bn-color") || "all") === color; }) || visibles[0];
      if (preferida) mostrar(preferida);
    };

    var colorInicial = root.getAttribute("data-bn-color-inicial");
    if (colorInicial) root.bnFiltrarColor(colorInicial);
  }

  function initGalerias() {
    document.querySelectorAll("[data-bn-galeria]").forEach(initGaleriaProducto);
  }

  function initVariantes() {
    document.querySelectorAll("[data-bn-form-producto]").forEach(function (form) {
      var dataEl = form.querySelector("[data-bn-variantes-json]");
      if (!dataEl) return;
      var variantes;
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var selects = form.querySelectorAll("[data-bn-opcion]");
      var idInput = form.querySelector("input[name='id']");
      var precioEl = form.querySelector("[data-bn-precio]");
      var precioComparadoEl = form.querySelector("[data-bn-precio-comparado]");
      var botonEl = form.querySelector("[data-bn-boton-comprar]");
      if (!selects.length || !idInput) return;

      var gridRoot = form.closest(".bn-producto-grid");
      var galeriaRoot = gridRoot ? gridRoot.querySelector("[data-bn-galeria]") : null;
      var urgenciaEl = gridRoot ? gridRoot.querySelector("[data-bn-urgencia]") : null;
      var selectColor = Array.prototype.find.call(selects, function (s) {
        return (s.getAttribute("data-bn-opcion-nombre") || "") === "color";
      }) || selects[0];

      var currencyCode = form.getAttribute("data-bn-currency") || "USD";
      var currencyLocale = document.documentElement.lang || "en-US";
      function moneda(cents) {
        try {
          return new Intl.NumberFormat(currencyLocale, { style: "currency", currency: currencyCode }).format(cents / 100);
        } catch (e) {
          return (cents / 100).toFixed(2) + " " + currencyCode;
        }
      }

      function actualizar() {
        var valores = Array.prototype.map.call(selects, function (s) { return s.value; });
        var encontrada = variantes.find(function (v) {
          return v.options.every(function (opt, i) { return opt === valores[i]; });
        });
        if (!encontrada) return;
        idInput.value = encontrada.id;
        if (precioEl) precioEl.textContent = moneda(encontrada.price);
        if (precioComparadoEl) {
          if (encontrada.compare_at_price && encontrada.compare_at_price > encontrada.price) {
            precioComparadoEl.textContent = moneda(encontrada.compare_at_price);
            precioComparadoEl.style.display = "";
          } else {
            precioComparadoEl.style.display = "none";
          }
        }
        if (botonEl) {
          if (encontrada.available) {
            botonEl.disabled = false;
            botonEl.textContent = botonEl.getAttribute("data-texto-disponible") || botonEl.textContent;
          } else {
            botonEl.disabled = true;
            botonEl.textContent = botonEl.getAttribute("data-texto-agotado") || "Sold out";
          }
        }
        if (galeriaRoot && galeriaRoot.bnFiltrarColor && selectColor) {
          galeriaRoot.bnFiltrarColor(selectColor.value);
        }
        if (urgenciaEl && selectColor) {
          var colorObjetivo = urgenciaEl.getAttribute("data-bn-color-objetivo") || "";
          var coincideUrgencia = selectColor.value.toLowerCase() === colorObjetivo;
          urgenciaEl.style.display = coincideUrgencia ? "" : "none";
        }
      }
      selects.forEach(function (s) { s.addEventListener("change", actualizar); });
      actualizar();
    });
  }

  function initMarquesinas() {
    document.querySelectorAll("[data-bn-marquee]").forEach(function (wrap) {
      var track = wrap.querySelector(".bn-marquee-track");
      if (!track || track.dataset.bnCloned) return;
      track.innerHTML += track.innerHTML;
      track.dataset.bnCloned = "1";
    });
  }

  function initTilt() {
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (window.matchMedia && window.matchMedia("(pointer: coarse)").matches) return;
    document.querySelectorAll("[data-bn-tilt]").forEach(function (card) {
      card.addEventListener("mousemove", function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = "perspective(800px) rotateY(" + (x * 6) + "deg) rotateX(" + (y * -6) + "deg) translateY(-4px)";
      });
      card.addEventListener("mouseleave", function () {
        card.style.transform = "";
      });
    });
  }

  function initComparador() {
    document.querySelectorAll("[data-bn-comparador]").forEach(function (comp) {
      var handle = comp.querySelector("[data-bn-comparador-asa]");
      var after = comp.querySelector("[data-bn-comparador-after]");
      if (!handle || !after) return;
      var activo = false;
      function set(pct) {
        pct = Math.max(0, Math.min(100, pct));
        after.style.clipPath = "inset(0 " + (100 - pct) + "% 0 0)";
        handle.style.left = pct + "%";
      }
      function fromEvent(e) {
        var r = comp.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
        set((x / r.width) * 100);
      }
      handle.addEventListener("mousedown", function () { activo = true; });
      window.addEventListener("mouseup", function () { activo = false; });
      window.addEventListener("mousemove", function (e) { if (activo) fromEvent(e); });
      handle.addEventListener("touchstart", function () { activo = true; }, { passive: true });
      window.addEventListener("touchend", function () { activo = false; });
      window.addEventListener("touchmove", function (e) { if (activo) fromEvent(e); }, { passive: true });
      set(50);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initReveals();
    initContadores();
    initGalerias();
    initVariantes();
    initMarquesinas();
    initTilt();
    initComparador();
  });
})();
